/**
 * Copy plain text to the clipboard. Prefer navigator.clipboard; fall back to execCommand.
 * @param {string} text
 * @returns {Promise<boolean>} true if copy likely succeeded
 */
export async function copyTextToClipboard(text) {
  const value = text != null ? String(text) : "";
  if (!value) return false;

  if (typeof navigator !== "undefined" && navigator.clipboard?.writeText) {
    try {
      await navigator.clipboard.writeText(value);
      return true;
    } catch {
      // fall through to legacy path (permissions / insecure context)
    }
  }

  if (typeof document === "undefined") return false;
  try {
    const el = document.createElement("textarea");
    el.value = value;
    el.setAttribute("readonly", "");
    el.style.position = "fixed";
    el.style.left = "-9999px";
    document.body.appendChild(el);
    el.select();
    const ok = document.execCommand("copy");
    document.body.removeChild(el);
    return !!ok;
  } catch {
    return false;
  }
}
